module.exports = __webpack_public_path__ + "static/media/lol-bronze.4b074dfc.png";